import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const COSTS = "costs";

// Sottoscrizione in real-time ai costi dell'utente. Ritorna la funzione di unsubscribe.
export function subscribeCosts(userId, callback) {
  const q = query(collection(db, COSTS), where("userId", "==", userId));
  return onSnapshot(
    q,
    (snap) => callback(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => {
      console.warn("costs snapshot error:", err?.message || err);
      callback([]);
    }
  );
}

function normalize(data) {
  return {
    nome: (data.nome || "").trim(),
    importo: Number(data.importo) || 0,
    frequenza: data.frequenza || "mensile", // 'mensile' | 'annuale' | 'una-tantum'
    categoria: data.categoria || "altro", // 'software' | 'servizi' | 'altro'
    ribaltato: Boolean(data.ribaltato),
    clientId: data.clientId || null, // opzionale: cliente a cui è ribaltato il costo
    prossimoRinnovo: data.prossimoRinnovo || null, // 'YYYY-MM-DD'
  };
}

export async function addCost(userId, data) {
  return addDoc(collection(db, COSTS), {
    userId,
    ...normalize(data),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateCost(id, data) {
  return updateDoc(doc(db, COSTS, id), {
    ...normalize(data),
    updatedAt: serverTimestamp(),
  });
}

export async function deleteCost(id) {
  return deleteDoc(doc(db, COSTS, id));
}

// Normalizza un costo a base ANNUA (per i totali del riepilogo).
export function annualize(cost) {
  const importo = Number(cost.importo) || 0;
  if (cost.frequenza === "mensile") return importo * 12;
  return importo; // 'annuale' e 'una-tantum' contati una volta
}
